import React from 'react';
import * as css from './Operations.css';
import Btn from '../button/btn/Btn';
import List from '../list/List';
import useShow from '../../hooks/useShow';

function OperationButton({item, index}) {
    const listShow = item.listData ? useShow() : null;
    
    return (
        <React.Fragment>
            <Btn className={index%2!==0&&'gray'} onClick={(e) => {
                if(item.listData) {
                    listShow?.open();
                } else if(item.onClick) {
                    item.onClick(e);
                }
            }}>
                {item.children?item.children: !item.withoutPlus&& <css.plus>{'+'}</css.plus>}
                {item.text}
            </Btn>
            {item.listData && listShow && (
                <List
                    list={item.listData}
                    showClass={listShow.showClass}
                    close={listShow.close}
                    {...item.listConfig}
                />
            )}
        </React.Fragment>
    );
}

export default OperationButton;
